import { WhyJoinMedrecruitCardType } from '@/app/modules/HomePageV2/types';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { useAnalytics } from '@/app/utils/useAnalytics';
import Image from 'next/image';

import { Theme, useMediaQuery } from '@material-ui/core';

import styles from './WhyJoinMedrecruitCard.module.scss';

export const WhyJoinMedrecruitCard = ({
  solutionSpecialistImageSrc,
  description,
  width,
  height,
}: WhyJoinMedrecruitCardType) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const track = useAnalytics();
  const profileUrl = appClientConfig.practitionerProfileUrl ?? '';
  const signUpUrl = `${profileUrl}/sign-up`;

  const handleCardClick = () => {
    track('Click', {
      action: 'Why join Medrecruit card',
      'element text': `${description}`,
      'element type': 'card',
    });
  };

  return isDesktop ? (
    <a
      href={signUpUrl}
      className={styles.whyJoinMedrecruitCard}
      onClick={handleCardClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleCardClick();
        }
      }}
    >
      <div className={styles.imageWrapper}>
        <Image
          src={solutionSpecialistImageSrc}
          alt=""
          aria-hidden
          width={width}
          height={height}
          className={styles.image}
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <p className={styles.description}>{description}</p>
    </a>
  ) : (
    <div className={styles.whyJoinMedrecruitCard}>
      <p className={styles.description}>{description}</p>
    </div>
  );
};
